import { FC } from "react";
import { useFormContext } from "react-hook-form";

import { ApprovalErrorFields, useApprovalErrorFields } from "@ryde/controls";

export const BookingEditIneligibleApprove: FC = () => {
  const { getValues, setValue } = useFormContext();
  const { reasonDropdownItems, reasonCategoryDropdownItems } =
    useApprovalErrorFields({ getValues, setValue });

  return (
    <ApprovalErrorFields
      reasonDropdownItems={reasonDropdownItems}
      reasonCategoryDropdownItems={reasonCategoryDropdownItems}
    />
  );
};
